"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildToolMetadata = buildToolMetadata;
exports.collectToolCallAnnotations = collectToolCallAnnotations;
exports.readToolCallAnnotations = readToolCallAnnotations;
function buildToolMetadata(annotations) {
    const metadata = {
        ...(annotations.detail === undefined ? {} : { detail: annotations.detail }),
        ...(annotations.displayName === undefined ? {} : { displayName: annotations.displayName }),
    };
    return Object.keys(metadata).length === 0 ? undefined : metadata;
}
function collectToolCallAnnotations(messages) {
    const annotations = new Map();
    for (const message of messages) {
        if (!isRecord(message) || !Array.isArray(message['parts'])) {
            continue;
        }
        for (const part of message['parts']) {
            if (!isRecord(part)) {
                continue;
            }
            const toolCallId = part['toolCallId'];
            const parsed = isRecord(part['toolMetadata']) ? readToolCallAnnotations(part['toolMetadata']) : undefined;
            if (typeof toolCallId !== 'string' || parsed === undefined) {
                continue;
            }
            annotations.set(toolCallId, parsed);
        }
    }
    return annotations;
}
function readToolCallAnnotations(metadata) {
    const detail = readAnnotationString(metadata['detail']);
    const displayName = readAnnotationString(metadata['displayName']);
    if (detail === undefined && displayName === undefined) {
        return undefined;
    }
    return {
        ...(detail === undefined ? {} : { detail }),
        ...(displayName === undefined ? {} : { displayName }),
    };
}
function readAnnotationString(value) {
    return typeof value === 'string' && value.length > 0 ? value : undefined;
}
function isRecord(value) {
    return typeof value === 'object' && value !== null;
}
//# sourceMappingURL=tool-call-annotations.js.map